import Vue from "vue";
//import "@/stylus/main.styl";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import Vuetify from "vuetify/lib";
import { theme } from "@/config/globals";

Vue.use(Vuetify);

export default new Vuetify({
  iconfont: theme.iconfont,
  theme: {
    themes: {
      light: {
        primary: theme.colors.primary,
        secondary: theme.colors.secondary,
        accent: theme.colors.accent,
        error: theme.colors.error
      },
      dark: {
        primary: theme.colors.primary,
        secondary: theme.colors.secondary,
        accent: theme.colors.accent,
        error: theme.colors.error
      }
    }
  },
  icons: {
    iconfont: "md"
  }
});
